/**
 * Collection-status event types returned by `GET /v1/events`.
 *
 * Each event drives a fixed banner shown at the top of the subscriptions
 * domain pages. The five values map 1:1 to the backend `event` field and each
 * has its own copy; the first four share the destructive (red) visual
 * treatment while `WARNING` uses the yellow warning treatment.
 */
export const SubscriptionEvents = {
  /** Suspended account: pay pending subscriptions + reactivation fee. */
  FEE: 'FEE',
  /** Blocked by missing payment: pay before day 25 or a reactivation fee is added. */
  PRE_FEE: 'PRE_FEE',
  /** Last day to pay before automatic block at 00:00. */
  URGENT: 'URGENT',
  /** Preventive reminder: N days left to pay before losing access. */
  PREVENTIVE: 'PREVENTIVE',
  /** Upcoming payment heads-up: anticipate the payment for day N (yellow warning treatment). */
  WARNING: 'WARNING',
} as const;

/** Union of the five collection-status event types. */
export type SubscriptionEventType = typeof SubscriptionEvents[keyof typeof SubscriptionEvents];
